var WP = require("wpapi");
var wp = new WP({
  endpoint: "https://gehirnpfade.de/wp-json/",
});

export default wp;
